//#region IMPORT
import React, { Fragment, useState } from 'react';
/** Components Import */
import {
  Box,
  Stack,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
} from '@mui/material';
import { Button, Dialog } from '../../../../Components/MUIs';
import DocumentPreview from '../../../../Components/Ui/DocumentPreview';
import VideoPreview from '../../../../Components/Ui/VideoPreview';
/** Icons Import */
import {
  Description as DescriptionIcon,
  Movie as MovieIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
//#endregion

function M_TBS_CUSTOM(props) {
  const [documentPreviewOpen, setDocumentPreviewOpen] = useState(false);
  const [documentPreviewData, setDocumentPreviewData] = useState(null);
  const [selectedItemForPreview, setSelectedItemForPreview] = useState(null);
  const [videoPreviewOpen, setVideoPreviewOpen] = useState(false);
  const [videoPreviewData, setVideoPreviewData] = useState(null);

  const HandleItemClick = (item) => {
    let currentSelected =
      props.selectedType === 'video'
        ? props.selectedVideo
        : props.selectedType === 'education'
          ? props.selectedEducation
          : props.selectedWorkplan;

    let isSameItem = false;

    if (props.selectedType === 'video') {
      isSameItem =
        currentSelected && currentSelected.videoFileName === item.videoFileName;
    } else if (props.selectedType === 'education') {
      isSameItem =
        currentSelected && currentSelected.eduFileName === item.eduFileName;
    } else if (props.selectedType === 'workplan') {
      isSameItem =
        currentSelected && currentSelected.fileName === item.fileName;
    }
    if (isSameItem) {
      props.HandleConfirmPreview(null);
      return;
    }

    if (props.selectedType === 'video') {
      setSelectedItemForPreview(item);
      setVideoPreviewData({
        videoLocation: item.videoLocation || item.videoFilePath || '',
        videoFileName: item.videoFileName || '교육 동영상',
      });
      setVideoPreviewOpen(true);
      return;
    }

    if (props.selectedType === 'education') {
      const filePath = item.eduLocation || item.eduFilePath || '';
      setSelectedItemForPreview(item);
      setDocumentPreviewData({
        filePath: filePath,
        fileNm: item.eduFileName || '교육 파일',
      });
      setDocumentPreviewOpen(true);
      return;
    }

    if (props.selectedType === 'workplan') {
      const filePath = item.filePath || item.filePath || '';
      setSelectedItemForPreview(item);
      setDocumentPreviewData({
        filePath: filePath,
        fileNm: item.fileName || '작업계획서',
      });
      setDocumentPreviewOpen(true);
      return;
    }
  };

  const HandleMenuClick = (type) => {
    if (props.HandleSelectType) {
      props.HandleSelectType(type);
    }
  };

  const menuItems = [
    {
      id: 'video',
      label: '교육 동영상',
      icon: MovieIcon,
      bgColor: '#E0EDFF',
      type: 'video',
    },
    {
      id: 'education',
      label: '교육 파일',
      icon: DescriptionIcon,
      bgColor: '#E8F7E4',
      type: 'education',
    },
    {
      id: 'workplan',
      label: '작업계획서',
      icon: AssignmentIcon,
      bgColor: '#FFE9E9',
      type: 'workplan',
    },
  ];

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          TBM 자료 선택
        </Typography>
        <Typography sx={{ color: '#828282', mb: 1 }}>
          교육 동영상, 교육 파일, 작업계획서를 선택해주세요.
        </Typography>
        <Typography sx={{ color: '#999', fontSize: '13px' }}>
          • 교육 동영상, 교육 파일: 해당 부서에 등록된 모든 자료
        </Typography>
        <Typography sx={{ color: '#999', fontSize: '13px' }}>
          • 작업계획서: 최근 3년동안 등록된 자료
        </Typography>
      </Stack>
      <Box sx={{ px: 2, pb: 2 }}>
        <Grid container spacing={2}>
          {menuItems.map((item) => {
            const IconComponent = item.icon;
            const isSelected =
              (item.type === 'video' &&
                props.selectedVideo &&
                props.selectedVideo.videoFileName) ||
              (item.type === 'education' &&
                props.selectedEducation &&
                props.selectedEducation.eduFileName) ||
              (item.type === 'workplan' &&
                props.selectedWorkplan &&
                props.selectedWorkplan.fileName);

            let selectedName = '';
            if (item.type === 'video' && props.selectedVideo) {
              selectedName = props.selectedVideo.videoFileName || '선택됨';
            } else if (item.type === 'education' && props.selectedEducation) {
              selectedName = props.selectedEducation.eduFileName || '선택됨';
            } else if (item.type === 'workplan' && props.selectedWorkplan) {
              selectedName = props.selectedWorkplan.fileName || '선택됨';
            }

            return (
              <Grid item xs={12} key={item.id}>
                <Card
                  onClick={() => HandleMenuClick(item.type)}
                  sx={{
                    borderRadius: 3,
                    height: '100%',
                    p: 0,
                    m: 0,
                    backgroundColor: item.bgColor,
                    cursor: 'pointer',
                    border: isSelected ? '2px solid #1976d2' : 'none',
                    '&:hover': {
                      boxShadow: 3,
                    },
                  }}
                >
                  <CardContent
                    sx={{
                      '&:last-child': { pb: 1 },
                      p: 2,
                      m: 0,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: 2,
                    }}
                  >
                    <Box
                      sx={{
                        flex: 1,
                        minWidth: 0, // flexbox에서 overflow 처리
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mb: 1,
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          sx={{
                            fontSize: '18px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {item.label}
                        </Typography>
                        {isSelected && (
                          <CheckCircleIcon
                            sx={{
                              color: '#1976d2',
                              fontSize: '20px',
                              flexShrink: 0,
                            }}
                          />
                        )}
                      </Box>
                      {isSelected && (
                        <Chip
                          label={selectedName}
                          size="small"
                          sx={{
                            backgroundColor: '#fff',
                            fontSize: '12px',
                            maxWidth: '100%',
                            width: 'fit-content',
                            '& .MuiChip-label': {
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              maxWidth: '200px',
                            },
                          }}
                        />
                      )}
                    </Box>
                    <IconComponent
                      sx={{
                        width: 80,
                        height: 80,
                        color: '#575757',
                        flexShrink: 0, // 아이콘이 줄어들지 않도록
                      }}
                    />
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
      {/* 저장 버튼 */}
      <Box sx={{ px: 2, pb: 2, pt: 2 }}>
        <Button
          name="저장"
          fullWidth
          onClick={props.SaveLogic1}
          sx={{
            fontSize: '16px',
            fontWeight: 'bold',
            py: 1.5,
          }}
        />
      </Box>
      {/* 리스트 선택 다이얼로그 */}
      <Dialog
        title={props.listTitle}
        open={props.listDialogOpen}
        onClose={() => props.setListDialogOpen(false)}
        sx={{ height: '90vh' }}
        titleSx={{ fontSize: '18px', fontWeight: 'bold', pt: 3 }}
        contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
        actionsSx={{ p: 0 }}
        PaperProps={{
          sx: {
            m: 2,
            borderRadius: 4,
            width: 'calc(100% - 32px)', // 좌우 마진 고려한 전체 너비
            maxWidth: '100%', // 혹시 모를 제한 제거
          },
        }}
        fullWidth={true}
        useSaveButton={false}
        useSaveAfterClose={false}
        useCloseButton={false}
        onSave={() => { }}
        maxWidth={false}
        content={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                width: '100%',
                maxHeight: '60vh',
                overflow: 'auto',
                mb: 2,
              }}
            >
              {props.listData.length === 0 ? (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 3,
                    minHeight: '200px',
                  }}
                >
                  <Typography sx={{ color: '#888' }}>
                    조회된 데이터가 없습니다.
                  </Typography>
                </Box>
              ) : (
                <List>
                  {props.listData.map((item, index) => {
                    let displayText = '';
                    if (props.selectedType === 'video') {
                      displayText = item.videoFileName || `동영상 ${index + 1}`;
                    } else if (props.selectedType === 'education') {
                      displayText = item.eduFileName || `파일 ${index + 1}`;
                    } else if (props.selectedType === 'workplan') {
                      displayText = item.fileName || `작업계획서 ${index + 1}`;
                    }

                    let isSelected = false;

                    if (props.selectedType === 'video') {
                      isSelected =
                        props.selectedVideo &&
                        props.selectedVideo.videoFileName ===
                        item.videoFileName;
                    } else if (props.selectedType === 'education') {
                      isSelected =
                        props.selectedEducation &&
                        props.selectedEducation.eduFileName ===
                        item.eduFileName;
                    } else if (props.selectedType === 'workplan') {
                      isSelected =
                        props.selectedWorkplan &&
                        props.selectedWorkplan.fileName === item.fileName;
                    }

                    return (
                      <Fragment key={index}>
                        <ListItem disablePadding>
                          <ListItemButton
                            onClick={() => HandleItemClick(item)}
                            sx={{
                              backgroundColor: isSelected
                                ? 'rgba(25, 118, 210, 0.08)'
                                : 'transparent',
                              '&:hover': {
                                backgroundColor: 'rgba(25, 118, 210, 0.15)',
                              },
                              borderLeft: isSelected
                                ? '4px solid #1976d2'
                                : '4px solid transparent',
                            }}
                          >
                            <ListItemText
                              primary={displayText}
                              sx={{
                                '& .MuiListItemText-primary': {
                                  fontSize: '16px',
                                  fontWeight: isSelected ? 'bold' : 'normal',
                                  color: isSelected ? '#1976d2' : 'inherit',
                                },
                              }}
                            />

                            {isSelected && (
                              <CheckCircleIcon
                                sx={{
                                  color: '#1976d2',
                                  fontSize: '20px',
                                  ml: 1,
                                }}
                              />
                            )}
                          </ListItemButton>
                        </ListItem>

                        {index < props.listData.length - 1 && <Divider />}
                      </Fragment>
                    );
                  })}
                </List>
              )}
            </Box>

            <Button
              sx={{
                width: '100%',
                height: '36px',
                borderRadius: '18px',
              }}
              name={'닫기'}
              onClick={() => props.setListDialogOpen(false)}
            />
          </Box>
        }
      />
      {/* 동영상 미리보기 (VideoPreview 컴포넌트 사용) */}
      {videoPreviewData && (
        <VideoPreview
          open={videoPreviewOpen}
          onClose={() => {
            setVideoPreviewOpen(false);
            // 동영상 미리보기 닫을 때 리스트 다이얼로그 다시 열기
            if (props.setListDialogOpen) {
              props.setListDialogOpen(true);
            }
            setTimeout(() => {
              setVideoPreviewData(null);
              setSelectedItemForPreview(null);
            }, 300);
          }}
          videoData={videoPreviewData}
          onConfirm={() => {
            // 확인 버튼 클릭 시 선택 저장
            if (selectedItemForPreview) {
              props.HandleConfirmPreview(selectedItemForPreview);
            }
            setVideoPreviewOpen(false);
            // 확인 버튼을 눌렀을 때는 리스트 다이얼로그도 닫기
            if (props.setListDialogOpen) {
              props.setListDialogOpen(false);
            }
            setTimeout(() => {
              setVideoPreviewData(null);
              setSelectedItemForPreview(null);
            }, 300);
          }}
        />
      )}
      {/* 문서 미리보기 (교육 파일, 작업계획서) */}
      {documentPreviewData && (
        <DocumentPreview
          open={documentPreviewOpen}
          onClose={() => {
            setDocumentPreviewOpen(false);
            // 문서 미리보기 닫을 때 리스트 다이얼로그 다시 열기
            if (props.setListDialogOpen) {
              props.setListDialogOpen(true);
            }
            // 확인 버튼을 통해 선택 저장하도록 하기 위해 닫을 때는 데이터만 초기화
            setTimeout(() => {
              setDocumentPreviewData(null);
              setSelectedItemForPreview(null);
            }, 300);
          }}
          documentData={documentPreviewData}
          onConfirm={() => {
            // 확인 버튼 클릭 시 선택 저장
            if (selectedItemForPreview) {
              props.HandleConfirmPreview(selectedItemForPreview);
            }
            setDocumentPreviewOpen(false);
            // 확인 버튼을 눌렀을 때는 리스트 다이얼로그도 닫기
            if (props.setListDialogOpen) {
              props.setListDialogOpen(false);
            }
            setTimeout(() => {
              setDocumentPreviewData(null);
              setSelectedItemForPreview(null);
            }, 300);
          }}
        />
      )}
    </>
  );
}

export default M_TBS_CUSTOM;
